import React, { useState } from 'react';
import { EXPENSE_MANAGEMENT_TABS } from '../Constants/Tabs';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Col, Row } from 'react-bootstrap';

const ExpenseManagementSec2 = () => {
    const [tabIndex, setTabIndex] = useState(0);

    return (
        <Row>
            <Col sm={12} lg={6}>
                {EXPENSE_MANAGEMENT_TABS.map((item, index) => {
                    let isMatched = index === tabIndex;
                    let MatchedIcon = isMatched ? KeyboardArrowDownIcon : ChevronRightIcon;
                    return (
                        <div key={index} onClick={() => setTabIndex(index)}>
                            <h1><MatchedIcon /> {item.title}</h1>
                            {isMatched && <img src={item.svg} alt="expense_management_tabs" loading='lazy' />}
                            <p>{isMatched && item.subPara}</p>
                        </div>
                    );
                })}
            </Col>
            <Col sm={12} lg={6}>
                {EXPENSE_MANAGEMENT_TABS.map((item, index) => {
                    return (
                        <div key={index}>
                            {index === tabIndex &&
                                <img src={item.svg} alt="expense_management_tabs" loading='lazy' />
                            }
                        </div>
                    );
                })}
            </Col>
        </Row>
    );
};

export default ExpenseManagementSec2;